import type { Lang } from "../lib/i18n";
import { pick } from "../lib/i18n";
import type { AppIntegration } from "../data/apps";
import { systemName, systemCategory, systemDesc, systemAccess } from "../data/systems";
import { QRCode } from "./QRCode";

/** Detailed system card shown in the systems carousel. */
export function SystemCard({ sys, lang }: { sys: AppIntegration; lang: Lang }) {
  const t = (ar: string, en: string) => pick(lang, ar, en);
  return (
    <div className="kd-sys-card kd-sys-card-centered" style={{ borderColor: sys.color + "44" }}>
      <div className="kd-sys-card-header">
        <div className="kd-sys-icon-wrap" style={{ background: sys.bgColor }}>
          <img src={sys.icon} alt={systemName(sys, lang)} className="kd-sys-logo-img" />
        </div>
        <div className="kd-sys-card-titles">
          <h2 className="kd-sys-name">{systemName(sys, lang)}</h2>
          <span className="kd-sys-cat" style={{ color: sys.color }}>{systemCategory(sys, lang)}</span>
        </div>
      </div>

      <p className="kd-sys-desc">{systemDesc(sys, lang)}</p>

      <div className="kd-sys-meta-section">
        <div className="kd-sys-meta-label">{t("طريقة الوصول", "How to Access")}</div>
        <p className="kd-sys-access-text">{systemAccess(sys, lang)}</p>
      </div>

      {sys.url && (
        <a href={sys.url} target="_blank" rel="noopener noreferrer" className="kd-sys-link" style={{ borderColor: sys.color + "44", color: sys.color }}>
          {t("فتح النظام على المتصفح", "Open in browser")} ↗
        </a>
      )}

      {sys.hasApp && (sys.ios || sys.android) && (
        <div className="kd-sys-app-section">
          <div className="kd-sys-meta-label">
            {sys.appName ? `${t("تحميل تطبيق", "Download App")} ${sys.appName}` : t("تحميل التطبيق", "Download App")}
          </div>
          <p className="kd-sys-app-hint">
            {t("لاستخدام النظام على الجوال، امسح رمز QR أدناه لتحميل التطبيق.", "To use the system on mobile, scan the QR code below to download the app.")}
          </p>
          <div className="kd-sys-app-links">
            {sys.ios && (
              <div className="kd-sys-store-col">
                <div className="kd-sys-qr-wrap">
                  <QRCode url={sys.ios} size={80} />
                </div>
                <a href={sys.ios} target="_blank" rel="noopener noreferrer" className="kd-sys-store-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <span>App Store</span>
                </a>
              </div>
            )}
            {sys.android && (
              <div className="kd-sys-store-col">
                <div className="kd-sys-qr-wrap">
                  <QRCode url={sys.android} size={80} />
                </div>
                <a href={sys.android} target="_blank" rel="noopener noreferrer" className="kd-sys-store-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3.18 23.04c.17.3.51.46.86.4l7.96-4.58-2.01-1.1-6.81 5.28zm-.18-1.36L9.98 12 3 2.32v19.36zm17.82-10.69L18.1 9.5l-3.38 1.95L18.1 13.5l2.72-1.57.43-.25a.75.75 0 0 0 0-1.3l-.43-.24zM3.53.98c-.37-.07-.73.1-.9.43L10.35 9.5l2.33-1.35L3.53.98zM14.6 10.95L12.27 12.3l2.33 1.35 3.37-1.95-3.37-1.94v.19z" />
                  </svg>
                  <span>Google Play</span>
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
